import React from 'react';
import styles from './CarouselSettings.module.scss';
import ActiveStatusBadge from '../../../components/ActiveStatusBadge';

const CarouselList = ({ carusels, selectedCaruselId, setSelectedCaruselId }) => {
  return (
    <div className={styles.carouselSelection}>
      <h2>Список каруселей</h2>
      <select
        value={selectedCaruselId}
        onChange={(e) => setSelectedCaruselId(e.target.value)}
        className={styles.select}
      >
        <option value="">Оберіть карусель</option>
        {carusels.map((carusel) => (
          <option key={carusel._id} value={carusel._id} style={carusel.active ?  { backgroundColor: "#ccffcc" }  
        : { backgroundColor: '#dc3545', fontWeight: 'bold', color: '#fff' }} >
            {carusel.title} <ActiveStatusBadge active={carusel.active}/>
          </option>
        ))}
      </select>
      {!selectedCaruselId && (
        <p className={styles.errorMessage}>Спочатку оберіть або створіть карусель</p>
      )}
    </div>
  );
};

export default CarouselList;
